export function NotFound() {
    return <div>404</div>
}